import CleanLayout from "@/layouts/Clean";
import HomeLayout from "@/layouts/Home";

const LoginPage = () => import("@/views/Login");
const DashboardPage = () => import("@/views/dashboard");
const usersetting = () => import("@/views/user");
const familySetting = () => import("@/views/family");
const EmployeeInfo = () => import("@/views/employe");
const masterUser = () => import("@/views/master_user");
const taxStatus = () => import("@/views/tax_status");
const taxStatusFamily = () => import("@/views/tax_status/detailKeluarga");
const masterUserEdit = () => import("@/views/master_user/edit");
const masterUserAdd = () => import("@/views/master_user/add");
const masterLeave = () => import("@/views/master_leave");
const masterLeaveEdit = () => import("@/views/master_leave/edit");
const masterLeaveAdd = () => import("@/views/master_leave/add");
const masterCost = () => import("@/views/master_cost");
const masterCostAdd = () => import("@/views/master_cost/add");
const masterCostEdit = () => import("@/views/master_cost/edit");
const masterJobgrade = () => import("@/views/master_jobgrade");
const masterJobgradeEdit = () => import("@/views/master_jobgrade/edit");
const masterJobgradeAdd = () => import("@/views/master_jobgrade/add");
const masterPosition = () => import("@/views/master_position");
const masterPositionEdit = () => import("@/views/master_position/edit");
const masterPositionAdd = () => import("@/views/master_position/add");
const masterTax = () => import("@/views/master_tax");
const masterDepartemen = () => import("@/views/master_departement");
const masterDepartemenEdit = () => import("@/views/master_departement/edit");
const masterDepartemenAdd = () => import("@/views/master_departement/add");
const masterTaxEdit = () => import("@/views/master_tax/edit");
const masterTaxAdd = () => import("@/views/master_tax/add");
const roleManagemt = () => import("@/views/master_role");
const roleManagemtAdd = () => import("@/views/master_role/add");
const roleManagemtEdit = () => import("@/views/master_role/edit");
const password = () => import("@/views/setting/password.vue");
const profile_picture = () => import("@/views/setting/profile_picture.vue");
const userFasilitas = () => import("@/views/fasilitas/userFasilitas.vue");
const masterFacilities = () => import("@/views/masterFacilities/index.vue");
const masterRace = () => import("@/views/master_race/index.vue");
const assessment = () => import("@/views/assessment/index.vue");
const masterHealth = () => import("@/views/master_health/index.vue");
const masterOwnership = () => import("@/views/master_ownership/index.vue");
const masterintitusi = () => import("@/views/master_institusi/index.vue");
const masterrelationship = () =>
  import("@/views/master_relationship/index.vue");
const masterterminationreason = () =>
  import("@/views/master_terminationreason/index.vue");
const seragam = () => import("@/views/seragam/seragam.vue");
const skill = () => import("@/views/skill/skill.vue");
const hobby = () => import("@/views/hobby/hobby.vue");
const health = () => import("@/views/health/health.vue");
const deciplines = () => import("@/views/deciplines/");
const master_store = () => import("@/views/master_store/");
const education = () => import("@/views/education/");
const educationAdd = () => import("@/views/education/add.vue");
const educationEdit = () => import("@/views/education/edit.vue");
const jobexperience = () => import("@/views/jobexperience/");
const jobexperienceAdd = () => import("@/views/jobexperience/add.vue");
const jobexperienceEdit = () => import("@/views/jobexperience/edit.vue");
const documentControl = () => import("@/views/document_control/");
const history_career = () => import("@/views/history_career/");
const history_careerAdd = () => import("@/views/history_career/add.vue");
const history_careerEdit = () => import("@/views/history_career/edit.vue");
// const career_transisition = () => import("@/views/masterCareerTransisition/index.vue");
// const career_transisitionForm = () => import("@/views/masterCareerTransisition/form.vue");
const master_career_transisition = () =>
  import("@/views/masterCareerTransisition/index.vue");
const master_career_transisition_form = () =>
  import("@/views/masterCareerTransisition/form.vue");
const career_transisition = () => import("@/views/career_transisition/");
export default [
  {
    path: "",
    redirect: "/login",
    name: "UnAuthenticated",
    component: CleanLayout,
    children: [
      {
        path: "/login",
        name: "Login",
        component: LoginPage,
        meta: {
          permission: "all",
          guest: true
        }
      }
    ]
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    redirect: "/dashboard",
    component: HomeLayout,
    children: [
      {
        path: "/unauthorized",
        name: "unauthorized",
        meta: {
          permission: "all",
          requireAuth: true
        },
        component: () => import("@/views/unauthorized.vue")
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        component: DashboardPage,
        meta: {
          permission: "all",
          requireAuth: true
        }
      },
      {
        path: "/address",
        name: "address",
        component: usersetting,
        meta: {
          permission: "address",
          requireAuth: true
        }
      },
      {
        path: "/additional-info",
        name: "Family",
        component: familySetting,
        meta: {
          permission: "Family",
          requireAuth: true
        }
      },
      {
        path: "/employee",
        name: "Employee",
        component: EmployeeInfo,
        meta: {
          permission: "Employee",
          requireAuth: true
        }
      },
      {
        path: "/master-user",
        name: "Master User",
        component: masterUser,
        meta: {
          permission: "Master User",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/tax-status",
        name: "Tax Status",
        component: taxStatus,
        meta: {
          permission: "Tax Status",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/tax-status/family/:id",
        name: "Tax Status Detail",
        component: taxStatusFamily,
        meta: {
          permission: "Tax Status",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-user/edit/:id",
        name: "Master User Edit",
        component: masterUserEdit,
        meta: {
          permission: "Master User",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-user/add/",
        name: "Master User Add",
        component: masterUserAdd,
        meta: {
          permission: "Master User",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-leave",
        name: "Master Leave Allowance",
        component: masterLeave,
        meta: {
          permission: "Master Leave Allowance",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-leave/add/",
        name: "Master Leave Allowance",
        component: masterLeaveAdd,
        meta: {
          permission: "Master Leave Allowance",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-leave/edit/:id",
        name: "Master Leave Allowance Edit",
        component: masterLeaveEdit,
        meta: {
          permission: "Master Leave Allowance",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-cost/",
        name: "Master Cost Center",
        component: masterCost,
        meta: {
          permission: "Master Cost Center",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-cost/add/",
        name: "Master Cost Center Add",
        component: masterCostAdd,
        meta: {
          permission: "Master Cost Center",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-cost/edit/:id",
        name: "Master Cost Center Edit",
        component: masterCostEdit,
        meta: {
          permission: "Master Cost Center",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-job-grade/",
        name: "Master Job Grade",
        component: masterJobgrade,
        meta: {
          permission: "Master Job Grade",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-job-grade/edit/:id",
        name: "Master Job Grade Edit",
        component: masterJobgradeEdit,
        meta: {
          permission: "Master Job Grade",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-job-grade/add/",
        name: "Master Job Grade Add",
        component: masterJobgradeAdd,
        meta: {
          permission: "Master Job Grade",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-position/",
        name: "Master Position",
        component: masterPosition,
        meta: {
          permission: "Master Position",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-position/edit/:id",
        name: "Master Position Edit",
        component: masterPositionEdit,
        meta: {
          permission: "Master Position",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-position/add/",
        name: "Master Position Add",
        component: masterPositionAdd,
        meta: {
          permission: "Master Position",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-departemen/",
        name: "Master Departemen",
        component: masterDepartemen,
        meta: {
          permission: "Master Departemen",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-departemen/edit/:id",
        name: "Master Departemen Edit",
        component: masterDepartemenEdit,
        meta: {
          permission: "Master Departemen",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-departemen/add/",
        name: "Master Departemen Add",
        component: masterDepartemenAdd,
        meta: {
          permission: "Master Departemen",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-tax/",
        name: "Master Pejak",
        component: masterTax,
        meta: {
          permission: "Master Pajak",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-tax/edit/:id",
        name: "Master Pejak Edit",
        component: masterTaxEdit,
        meta: {
          permission: "Master Position",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/master-tax/add/",
        name: "Master Pejak Add",
        component: masterTaxAdd,
        meta: {
          permission: "Master Position",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/role-management/",
        name: "Role Management",
        component: roleManagemt,
        meta: {
          permission: "Role Managemen",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/role-management/add/",
        name: "Role Management Add",
        component: roleManagemtAdd,
        meta: {
          permission: "Role Managemen",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/role-management/edit/:id",
        name: "Role Management Edit",
        component: roleManagemtEdit,
        meta: {
          permission: "Role Managemen",
          requireAuth: true,
          is_admin: true
        }
      },
      {
        path: "/setting/password/",
        name: "setting-password",
        component: password,
        meta: {
          permission: "all",
          requireAuth: true
        }
      },
      {
        path: "/setting/profile/",
        name: "setting-profile",
        component: profile_picture,
        meta: {
          permission: "all",
          requireAuth: true
        }
      },
      {
        path: "/facilities",
        name: "user-facilities",
        component: userFasilitas,
        meta: {
          permission: "Fasilitas",
          requireAuth: true
        }
      },
      {
        path: "/master-facilities",
        name: "master-facilities",
        component: masterFacilities,
        meta: {
          permission: "master-facilities",
          requireAuth: true
        }
      },
      {
        path: "/master-race",
        name: "master-race",
        component: masterRace,
        meta: {
          permission: "master-race",
          requireAuth: true
        }
      },
      {
        path: "/master-health",
        name: "master-health",
        component: masterHealth,
        meta: {
          permission: "master-health",
          requireAuth: true
        }
      },
      {
        path: "/master-ownership",
        name: "master-ownership",
        component: masterOwnership,
        meta: {
          permission: "master-ownership",
          requireAuth: true
        }
      },
      {
        path: "/master-institution",
        name: "master-institution",
        component: masterintitusi,
        meta: {
          permission: "master-institution",
          requireAuth: true
        }
      },
      {
        path: "/master-relationship",
        name: "master-relationship",
        component: masterrelationship,
        meta: {
          permission: "master-relationship",
          requireAuth: true
        }
      },
      {
        path: "/master-termination-reason",
        name: "master-termination-reason",
        component: masterterminationreason,
        meta: {
          permission: "master-termination-reason",
          requireAuth: true
        }
      },
      {
        path: "/uniform",
        name: "Uniform",
        component: seragam,
        meta: {
          permission: "Uniform",
          requireAuth: true
        }
      },
      {
        path: "/skill",
        name: "Skill",
        component: skill,
        meta: {
          permission: "Skill",
          requireAuth: true
        }
      },
      {
        path: "/assessment",
        name: "Assessment",
        component: assessment,
        meta: {
          permission: "assessment",
          requireAuth: true
        }
      },
      {
        path: "/curriculum-vitae",
        name: "cv",
        component: () => import("@/views/templateCV.vue"),
        meta: {
          permission: "curriculum-vitae",
          requireAuth: true
        }
      },
      {
        path: "/benchmark",
        name: "benchmark",
        component: () => import("@/views/report_karyawan/bencmark.vue"),
        meta: {
          permission: "curriculum-vitae",
          requireAuth: true
        }
      },
      {
        path: "/report-karyawan",
        name: "Report karyawan",
        component: () => import("@/views/report_karyawan/index.vue"),
        meta: {
          permission: "report-karyawan",
          requireAuth: true
        }
      },
      {
        path: "/assessment",
        name: "Assessment",
        component: () => import("@/views/assessment/index.vue"),
        meta: {
          permission: "assessment",
          requireAuth: true
        }
      },
      {
        path: "/assessment/add",
        name: "Assessment Detail",
        component: () => import("@/views/assessment/form.vue"),
        meta: {
          permission: "assessment",
          requireAuth: true
        }
      },
      {
        path: "/assessment/:id/edit",
        name: "Assessment Edit",
        component: () => import("@/views/assessment/form.vue"),
        meta: {
          permission: "assessment",
          requireAuth: true
        }
      },
      {
        path: "/master/strata",
        name: "Master Strata",
        component: () => import("@/views/masterStrata/index.vue"),
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/master/strata/add",
        name: "Master Strata Tambah",
        component: () => import("@/views/masterStrata/form.vue"),
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/master/strata/:id/edit",
        name: "Master Strata Edit",
        component: () => import("@/views/masterStrata/form.vue"),
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/export/:id/curriculum-vitae",
        name: "cv",
        component: () => import("@/views/templateCV.vue"),
        meta: {
          permission: "Master User",
          requireAuth: true
        }
      },
      {
        path: "/hobby",
        name: "Hobby",
        component: hobby,
        meta: {
          permission: "Hobby",
          requireAuth: true
        }
      },
      {
        path: "/job-experience",
        name: "Job Experience",
        component: jobexperience,
        meta: {
          permission: "Job Experience",
          requireAuth: true
        }
      },
      {
        path: "/job-experience/add",
        name: "Job Experience Add",
        component: jobexperienceAdd,
        meta: {
          permission: "Job Experience",
          requireAuth: true
        }
      },
      {
        path: "/job-experience/edit/:id",
        name: "Job Experience Edit",
        component: jobexperienceEdit,
        meta: {
          permission: "Job Experience",
          requireAuth: true
        }
      },
      {
        path: "/health",
        name: "Health ",
        component: health,
        meta: {
          permission: "Health",
          requireAuth: true
        }
      },
      {
        path: "/deciplenes",
        name: "Deciplines ",
        component: deciplines,
        meta: {
          permission: "Deciplines",
          requireAuth: true
        }
      },
      {
        path: "/master-location",
        name: "Master Location",
        component: master_store,
        meta: {
          permission: "Master Location",
          requireAuth: true
        }
      },
      {
        path: "/education",
        name: "Education",
        component: education,
        meta: {
          permission: "Education",
          requireAuth: true
        }
      },
      {
        path: "/education/add",
        name: "Add Education",
        component: educationAdd,
        meta: {
          permission: "Education",
          requireAuth: true
        }
      },
      {
        path: "/education/edit/:id",
        name: "Edit Education",
        component: educationEdit,
        meta: {
          permission: "Education",
          requireAuth: true
        }
      },
      {
        path: "/history-career",
        name: "History Career",
        component: history_career,
        meta: {
          permission: "History Career",
          requireAuth: true
        }
      },
      {
        path: "/history-career/add",
        name: "History Career",
        component: history_careerAdd,
        meta: {
          permission: "History Career",
          requireAuth: true
        }
      },
      {
        path: "/history-career/edit/:id",
        name: "History Career",
        component: history_careerEdit,
        meta: {
          permission: "History Career",
          requireAuth: true
        }
      },
      // {
      //   path: "/master/career-transisition",
      //   name: "Career Transisition",
      //   component: career_transisition,
      //   meta: {
      //     permission: "Master Career Transisition",
      //     requireAuth: true
      //   }
      // },
      // {
      //   path: "/master/career-transisition/add",
      //   name: "History Career",
      //   component: career_transisitionForm,
      //   meta: {
      //     permission: "Master Career Transisition",
      //     requireAuth: true
      //   }
      // },
      // {
      //   path: "/master/career-transisition/edit/:id",
      //   name: "History Career",
      //   component: career_transisitionForm,
      //   meta: {
      //     permission: "Master Career Transisition",
      //     requireAuth: true
      //   }
      // },
      {
        path: "/document-control",
        name: "Document Control",
        component: documentControl,
        meta: {
          permission: "Document Control",
          requireAuth: true
        }
      },
      {
        path: "/asset",
        name: "asset",
        component: () =>
          import(
            /* webpackChunkName: "routes" */ "@/views/assetManagement/index.vue"
          ),
        meta: {
          permission: "asset",
          requireAuth: true
        }
      },
      {
        path: "/asset/approval",
        name: "Approval Asset",
        component: () =>
          import(
            /* webpackChunkName: "routes" */ "@/views/assetManagement/approvalAsset/index.vue"
          ),
        meta: {
          permission: "Approval Asset",
          requireAuth: true
        }
      },
      {
        path: "/master/:id/career-transisition",
        name: "Master Career Transisition",
        component: master_career_transisition,
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/master/career-transisition/add",
        name: "Master Career Transisition",
        component: master_career_transisition_form,
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/master/career-transisition/add/:emp_no",
        name: "Master Career Transisition",
        component: master_career_transisition_form,
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/master/career-transisition/:id/edit",
        name: "Master Career Transisition",
        component: master_career_transisition_form,
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/master/career-transisition",
        name: "Master Career Transisition",
        component: master_career_transisition,
        meta: {
          permission: "Master Career Transisition",
          requireAuth: true
        }
      },
      {
        path: "/career-transisition",
        name: "Career Transisition",
        component: career_transisition,
        meta: {
          permission: "Career Transisition",
          requireAuth: true
        }
      }
    ]
  },
  {
    path: "*",
    name: "Not Found",
    component: () => import("@/views/NotFound.vue")
  }
];
